import FormPayloadEditor from '../form/FormPayloadEditor'
import type { AssetEditorProps } from './assetEditors'

const FormAssetEditor = ({ value, onChange, editable }: AssetEditorProps) => (
  <FormPayloadEditor yaml={value ?? ''} editable={editable ?? true} onChange={onChange} />
)

export default FormAssetEditor
